import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_get_order_data_blno_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id: number, op_code: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, RequestedDeliveryDate?: string, VendorReference?: string, PreferredWarehouse?: { Id?: number, Name?: string }, Account?: { Id?: number, Active?: boolean, LookupCode?: string, Name?: string, TypeId?: number, BillingContracts?: { Id?: number, Name?: string }[], AccountsContactsLookup?: { ContactId?: number, Contact?: { Id?: number, AddressId?: number, FirstName?: string, Greeting?: string, LastName?: string, Notes?: string } }[] }, Addresses?: { Id?: number, AttentionOf?: string, City?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, LookupCode?: string, PostalCode?: string, State?: string }[], Tasks?: { Id?: number, ActualExpirationDate?: string, ActualInventoryAmount?: number, ActualPackagedAmount?: number, ActualPackagedPackId?: number, GrossWeight?: number, LotId?: number, MaterialId?: number, NetWeight?: number, OperationCodeId?: number, Warehouse?: { Id?: number, Name?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string }, VendorLot?: { Id?: number, ExpirationDate?: string, LookupCode?: string }, Lot?: { Id?: number, LookupCode?: string }, ActualSourceLicensePlate?: { Id?: number, LookupCode?: string }, ActualTargetLicensePlate?: { Id?: number, LookupCode?: string }, OperationCode?: { Id?: number, Name?: string }, DimensionsUOM?: { Short_name?: string }, WeightUOM?: { Id?: number, Name?: string, Short_name?: string }, ActualPackagedPack?: { Id?: number, Name?: string, ShortName?: string } }[], Project?: { Id?: number, LookupCode?: string }, ShipmentOrderLookups?: { CreatedSysDateTime?: string, Shipment?: { Id?: number, LoadContainerId?: number, SealId?: string, TypeId?: number, Carrier?: { Id?: number, Name?: string, ShortName?: string, Services?: { Name?: string }[] }, DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number, DockAppointment?: { Id?: number, DriverLicense?: string, DriverName?: string, DriverPhone?: string, LookupCode?: string, Notes?: string } }[], TemperatureReadings?: { Id?: number, Temperature1?: number, Temperature1MeasurementUnitId?: number, Temperature2?: number, Temperature2MeasurementUnitId?: number, Temperature3?: number, Temperature3MeasurementUnitId?: number }[], Surveys?: { id?: number, contextData?: string, Inputs?: { id?: number, inputText?: string }[] }[] } }[] } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.op_code)) {
      $missingRequiredInParams.push('\'op_code\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id: number, op_code: number    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
        if(isNil($inParams.op_code)) {
          return true; 
        }
      return false;
    }
}
